import { unitService } from '../_services';

const getDefaultState = () => {
  return {
    loading: false,
    all: {},
    current: {},
    selectList: {}
  }
}

export const units = {
  namespaced: true,
  state: getDefaultState(),
  actions: {
    resetState ({ commit }) {
      commit('resetState')
    },
    getAllUnits({ commit }) {
      commit('getAllUnitsRequest');
      unitService.getAll()
      .then(
          units => commit('getAllUnitsSuccess', units),
          error => commit('getAllUnitsFailure', error)
      );
    },
    getSelectList({ commit }) {
      commit('getSelectListRequest');
      unitService.getSelectList()
      .then(
          operators => commit('getSelectListSuccess', operators),
          error => commit('getSelectListFailure', error)
      );
    },
    searchUnits({ commit }, qry) {
      commit('getAllUnitsRequest');
      unitService.searchUnits(qry)
      .then(
          units => commit('getAllUnitsSuccess', units),
          error => commit('getAllUnitsFailure', error)
      );
    },
    getById({ commit }, id) {
      commit('getByIdRequest');
      unitService.getById(id)
      .then(
        response => {
          commit('getByIdSuccess', response);
          return response;
        },
          error => {
            commit('getByIdFailure', error)
          return error;
          }
      );
    },
    addUnit({ commit }, payload){
      commit('addUnitRequest');
      unitService.addUnit(payload)
      .then(
        units => commit('addUnitSuccess', units),
        error => commit('addUnitFailure', error)
      )
    },
    updateUnit({ commit }, payload){
      commit('updateUnitRequest');
      unitService.updateUnit(payload)
      .then(
        units => commit('updateUnitSuccess', units),
        error => commit('updateUnitFailure', error)

      )
    },
    deleteUnit({ commit }, payload){
      commit('deleteUnitRequest');
      unitService.deleteUnit(payload)
      .then(
        commit('deleteUnitSuccess'),
        error => commit('deleteUnitFailure', error)
      )
      return true;
    }
  },
  mutations: {
    resetState (state) {
      Object.assign(state, getDefaultState())
    },
    getAllUnitsRequest(state) {
        state.loading = true;
    },
    getAllUnitsSuccess(state, units) {
        state.loading = false;
        state.all = Object.values(units);
    },
    getAllUnitsFailure(state, error) {
        state.loading = false;
    },
    getSelectListRequest(state) {
        state.selectList = { loading: true };
    },
    getSelectListSuccess(state, units) {
        units.unshift({ id: '', name: '' });
        state.selectList = Object.values(units);
    },
    getSelectListFailure(state, error) {
        state.selectList = { error };
    },
    getByIdRequest(state) {
      state.current = { loading: true };
    },
    getByIdSuccess(state, unit) {
      state.current = unit;
      return unit;
    },
    getByIdFailure(state, error) {
        state.current = { error };
    },
    addUnitRequest(state, unit) {
      state.current = unit
    },
    addUnitSuccess(state, unit) {
      if(unit.id == state.current.unit.id){
        state.current = unit;
      }
    },
    addUnitFailure(state, error) {
      state.update = { error };
    },
    updateUnitRequest(state, unit) {
      state.current = unit
    },
    updateUnitSuccess(state, unit) {
      if(unit.id == state.current.unit.id){
        state.current = unit;
      }
    },
    updateUnitFailure(state, error) {
      state.update = { error };
    },
    deleteUnitRequest(state, unit) {
      state.current = unit
    },
    deleteUnitSuccess(state) {
        state.current = {};
        return true;
    },
    deleteUnitFailure(state, error) {
      state.update = { error };
    }
  }
}